import { PORTALS } from './portals';

export default [PORTALS.MODAL, PORTALS.APP_BANNER];
